import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GenerateReportPdfRequestDtoSchema = z.object({
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
  facilityId: z.number().optional(),
  from: z.string(),
  to: z.string(),
});

const GenerateReportPdfResponseDtoSchema = z.object({
  reportUrl: z.string(),
});

export type GenerateReportPdfRequestDto = z.infer<
  typeof _GenerateReportPdfRequestDtoSchema
>;
export type GenerateReportPdfResponseDto = z.infer<
  typeof GenerateReportPdfResponseDtoSchema
>;

export const generateReportPdf = (
  params: GenerateReportPdfRequestDto,
  config?: AxiosRequestConfig<GenerateReportPdfRequestDto>
) => {
  return api
    .get('market-intel-subscription/report-pdf', { params, ...config })
    .then(responseContract(GenerateReportPdfResponseDtoSchema));
};
